import React, { memo, useContext, useMemo } from "react";
import Navbar from "app/components/Navbar";
import { cls } from "app/utils";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";
import GettingStartedProgress from "app/components/GettingStarted/GettingStartedProgress";
import Tabs from "app/components/Tabs";
import { UserContext, RoleType } from "app/contexts/UserContext";

interface IProps {
  children: React.ReactNode;
}

const AutomationLayout = ({ children }: IProps) => {
  const { t } = useTranslation();
  const user = useContext(UserContext);

  const isAdmin = user.role === RoleType.ADMIN;

  const tabs = useMemo(() => {
    return [{ label: t("Facility Workflows"), path: "/automation/facility-workflows" }];
  }, [t]);

  return (
    <div>
      <Navbar
        label={t("Automation")}
        hasSearch={false}
        hasNotifications={false}
      />
      <div className={cls(styles.container, "coach-home")}>
        {!isAdmin && <GettingStartedProgress />}
        <Tabs tabs={tabs} />
        {children}
      </div>
    </div>
  );
};

export default memo(AutomationLayout);
